// Firstfund's F mark, the same paths as App admin's and the Lender Hub's: the upright in the text colour, gold bars.
import { useId } from 'react'

export function FirstfundMark({ size = 18 }: { size?: number }) {
  const gold = useId()
  return (
    <svg width={Math.round(size * 1.09)} height={size} viewBox="0 0 558.545 512" aria-hidden="true">
      <defs>
        <linearGradient id={gold} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F2D27B" />
          <stop offset="0.55" stopColor="#D4A017" />
          <stop offset="1" stopColor="#A67A0B" />
        </linearGradient>
      </defs>
      <path d="M116.364 0 L209.455 0 L93.091 512 L0 512 Z" fill="currentColor" />
      <path d="M238.545 0 L558.545 0 L488.727 93.091 L217.596 93.091 Z" fill={`url(#${gold})`} />
      <path
        d="M206.545 151.273 L442.182 151.273 L372.364 244.364 L186.182 244.364 Z"
        fill={`url(#${gold})`}
      />
      <path d="M177.455 302.545 L250.182 512 L139.636 512 Z" fill={`url(#${gold})`} />
    </svg>
  )
}
